import { RootState } from "../../app";

const userSelector = (state: RootState) => state.userReducer.user;

export default userSelector;
